import React from 'react';
import XLogo from 'assets/images/lBlack.png';
import MiscLogo from 'assets/svgs/rss.svg';
import FBLogo from 'assets/images/fb-logo.png';
import InstaLogo from 'assets/images/insta-logo.png';
import TwitterWhiteLogo from 'components/TwitterWhiteLogo';

interface SocialLogoProps {
  social_network: string;
  style?: React.CSSProperties;
}

const SocialLogo: React.FC<SocialLogoProps> = ({ social_network, style }) => {
  if (social_network === 'facebook') return <img className="facebook-logo" src={FBLogo} alt="Facebook" style={style} />;
  if (social_network === 'twitter') return <img className="x-logo" src={XLogo} alt="X" style={style} />;
  if (social_network === 'x') return <TwitterWhiteLogo style={style} />;
  if (social_network == 'misc') return <img className="misc-logo" src={MiscLogo} alt="Misc" style={style} />;
  return <img className="instagram-logo" src={InstaLogo} alt="Instagram" style={style} />;
};

export default SocialLogo;
